import { render, staticRenderFns } from "./VPopover.vue?vue&type=template&id=c004a974"
import script from "./VPopover.vue?vue&type=script&lang=ts"
export * from "./VPopover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports